// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__34MXA","modalForm":"UpgradeEpcsModal_modalForm__3-NvA","modalFooter":"UpgradeEpcsModal_modalFooter__2Obfp"};